// extracted by mini-css-extract-plugin
module.exports = {"list":"NativeList_list__-X3Yv","listCol":"NativeList_listCol__2-vSQ"};